var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 75,
    viewBox: "0 0 54 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1213 27.3269C52.1213 12.7385 39.9173 1.03117 25.27 2.0634C12.969 2.92577 2.98221 12.9606 2.07079 25.3931C1.26925 36.3426 7.35185 45.9462 16.4014 50.2516C17.7588 50.8983 18.625 52.2768 18.625 53.7925V59.7964V64.3304C18.625 68.7076 21.7988 72.549 26.1038 73.0325C31.191 73.6009 35.5024 69.5895 35.5024 64.5591V53.7925C35.5024 52.2768 36.3751 50.8983 37.7325 50.2516C46.2326 46.1945 52.1213 37.4597 52.1213 27.3269Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4961 59.4502H18.6187",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0603 28.9531C22.1542 28.9531 18.1594 32.9906 18.1594 37.9492V43.1888C20.7644 44.7567 23.8089 45.6648 27.0603 45.6648C30.3117 45.6648 33.3562 44.7632 35.9612 43.1888V37.9492C35.9612 32.9906 31.9665 28.9531 27.0603 28.9531Z",
    fill: "#FCC240"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7705 37.9496C13.7705 30.5411 19.7303 24.5175 27.0604 24.5175C34.3906 24.5175 40.3503 30.5411 40.3503 37.9496V39.4326C42.923 36.3621 44.4743 32.3965 44.4743 28.065C44.4743 18.3438 36.6788 10.4648 27.0604 10.4648C17.442 10.4648 9.64648 18.3438 9.64648 28.065C9.64648 32.403 11.1978 36.3686 13.7705 39.4326V37.9496Z",
    fill: "#FCC240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.b4d55241aa983ec3c12283df0d98686a.svg";
export { ForwardRef as ReactComponent };